export default function($) {
  $('table').tablesorter();
}
